import { Col, Row } from "react-bootstrap";

interface IInverterInfo {
  title: string;
  value: string | React.ReactNode;
}

interface IProps {
  inverterInfo: IInverterInfo[];
}

const InverterInformation = (props: IProps) => {
  return (
    <>
      {props.inverterInfo.map((i, index) => {
        return (
          <Row key={index} className="my-3">
            <Col className="font-weight-400 font-size-14 text-light col-auto pe-0">
              {i.title}:
            </Col>
            <Col className="font-weight-400 font-size-14 text-dark">
              {i.value}
            </Col>
          </Row>
        );
      })}
    </>
  );
};

export default InverterInformation;
